import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
     const naviagation = localStorage.getItem('navigation');
    if (this.authService.loggedIn() && naviagation != 'forget-password') {
          this.router.navigate(['user']);
          return false;
    } else {
          localStorage.clear();
          return true;
    }
  }
}
